module.exports = __webpack_public_path__ + "img/CyA.fc3ce0ef.png";